import {
  Exercise,
  ExerciseDetails,
  ExerciseReference,
  WorkoutDetails,
  WorkoutRoutine,
} from "../api/types";
import { RoutineCard } from "./routines/RoutineCard.tsx";
import ExerciseLibrary from "./ExerciseLibrary.tsx";
import { WorkoutCard } from "./workouts/WorkoutCard.tsx";

export const sampleBarbellSquatExercise: Exercise = {
  id: "0",
  name: "Barbell Squat",
  description: "A compound exercise targeting the lower body.",
  primary_muscle_groups: [
    { muscle_group: "quadriceps", weight: 0.6 },
    { muscle_group: "glutes", weight: 0.2 },
  ],
  secondary_muscle_groups: [{ muscle_group: "hamstrings", weight: 0.2 }],
  start_resistance: 20,
  default_resistance_unit: "kg",
  efficiency_factor: 1,
};

export const sampleAngledLegPressExercise: Exercise = {
  id: "1",
  name: "Angled Leg Press",
  description: "A machine-based exercise for leg strength.",
  primary_muscle_groups: [
    { muscle_group: "quadriceps", weight: 0.5 },
    { muscle_group: "glutes", weight: 0.2 },
    { muscle_group: "hamstrings", weight: 0.2 },
  ],
  secondary_muscle_groups: [{ muscle_group: "calves", weight: 0.05 }],
  start_resistance: 45,
  default_resistance_unit: "kg",
  efficiency_factor: 0.74,
};

export const sampleBarbellSquatExerciseReference: ExerciseReference = {
  exercise_id: "0",
  resistance_unit: "kg",
  sets: [
    { repetitions: 10, resistance: 40 },
    { repetitions: 8, resistance: 50 },
    { repetitions: 6, resistance: 60 },
  ],
};

export const sampleAngledLegPressExerciseReference: ExerciseReference = {
  exercise_id: "1",
  resistance_unit: "kg",
  sets: [
    { repetitions: 12, resistance: 70 },
    { repetitions: 10, resistance: 90 },
    { repetitions: 8, resistance: 110 },
  ],
};

export const sampleBarbellSquatExerciseDetails: ExerciseDetails = {
  resistance_unit: "kg",
  sets: [
    { repetitions: 10, resistance: 40 },
    { repetitions: 8, resistance: 50 },
    { repetitions: 6, resistance: 60 },
  ],
  ...sampleBarbellSquatExercise,
};

export const sampleAngledLegPressExerciseDetails: ExerciseDetails = {
  resistance_unit: "kg",
  sets: [
    { repetitions: 12, resistance: 70 },
    { repetitions: 10, resistance: 90 },
    { repetitions: 8, resistance: 110 },
  ],
  ...sampleAngledLegPressExercise,
};

export const sampleWorkoutRoutine: WorkoutRoutine = {
  id: "1",
  name: "Lower Body Routine",
  exercises: [
    sampleBarbellSquatExerciseReference,
    sampleAngledLegPressExerciseReference,
  ],
};

const today = new Date();

export const sampleWorkout: WorkoutDetails = {
  id: "1",
  name: "Leg Day",
  status: "completed",
  visibility: "friends",
  exercises: [
    sampleBarbellSquatExerciseDetails,
    sampleAngledLegPressExerciseDetails,
  ],
  executed_at: new Date(
    today.getFullYear(),
    today.getMonth(),
    3,
    10,
    0,
    0,
  ).toISOString(),
};

export const SampleRoutineCard = ({ focusOnMenu = false }) => {
  return (
    <div className="pointer-events-none">
      <RoutineCard
        routine={sampleWorkoutRoutine}
        exercises={
          new Map([
            ["0", sampleBarbellSquatExercise],
            ["1", sampleAngledLegPressExercise],
          ])
        }
        onCreateWorkout={() => null}
        focusOnMenu={focusOnMenu}
        friends={[]}
      />
    </div>
  );
};

export const SampleWorkoutCard = () => {
  return (
    <div className="pointer-events-none">
      <WorkoutCard
        workout={sampleWorkout}
        exercises={
          new Map([
            ["0", sampleBarbellSquatExercise],
            ["1", sampleAngledLegPressExercise],
          ])
        }
        timeFormat="24h"
      />
    </div>
  );
};

export const SampleExerciseLibrary = () => {
  return (
    <div className="pointer-events-none">
      <ExerciseLibrary
        exercises={[sampleBarbellSquatExercise, sampleAngledLegPressExercise]}
        onSelectExercise={() => null}
        selectedExercises={[]}
        deselectExercises={() => null}
        untilLimit={100}
      />
    </div>
  );
};
